<div class="modal z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center p-8 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div
    class="bg-white w-full lg:max-w-screen-xl mx-auto rounded-lg shadow-xl z-50 overflow-y-auto"
    style="height: 90vh"
  >
    <div class="content p-8">
      <form [formGroup]="form" class="flex w-full h-full">
        <div class="flex flex-col h-full w-full mr-10 flex-4">
          <div class="flex flex-col border-b border-shuttle-gray pb-4">
            <h1 class="text-chathams-blue font-bold text-base leading-5 tracking-tight mb-3">Edição do Perfil</h1>

            <div>
              <div class="flex items-end justify-between gap-x-10">
                <div class="flex flex-col w-full max-w-xs">
                  <label class="font-normal text-xs text-blumine">Nome*</label>

                  <input formControlName="description" class="form-input" type="text" />
                </div>

                <div class="flex flex-col w-full max-w-5xl">
                  <label class="font-normal text-xs text-blumine">Observação do Perfil:</label>

                  <input formControlName="comments" class="form-input" type="text" />
                </div>

                <div *ngIf="isAdmOlive" class="text-sm text-chathams-blue font-medium leading-4 flex items-center">
                  <input
                    type="checkbox"
                    class="mr-3 form-input form-checkbox on-white check-pink"
                    formControlName="adminOlive"
                    (change)="convertCheckboxValue()"
                  />
                  <label>Admin Oliv-e </label>
                </div>
              </div>

              <div *ngIf="isAdmOlive" class="mt-3">
                <ng-select
                  notFoundText="Nenhum item encontrado"
                  [items]="partners"
                  placeholder="Parceiros"
                  formControlName="partnersId"
                  bindLabel="name"
                  bindValue="id"
                  [multiple]="true"
                >
                </ng-select>
              </div>
            </div>
          </div>

          <div class="wrapper mt-8">
            <label
              [ngClass]="[
                'rounded-xss items-center justify-center flex shadow-xl hover:bg-downy w-50',
                currentResource === resource.id ? 'selected bg-downy' : 'bg-iceberg'
              ]"
              *ngFor="let resource of resources"
            >
              <div class="flex flex-col items-center justify-center text-center w-44 m-5">
                <div
                  class="icon mb-2"
                  [ngStyle]="{
                    mask: 'url(/assets/icons/' + resource.icon + '.svg) no-repeat center / contain',
                    '-webkit-mask': 'url(/assets/icons/' + resource.icon + '.svg) no-repeat center / contain'
                  }"
                ></div>

                <span class="text-gray font-medium text-2xl leading-6 tracking-wider">{{ resource.description }}</span>
              </div>

              <input
                type="radio"
                id="{{ resource.id }}"
                [value]="resource.id"
                class="hidden"
                formControlName="resource"
              />
            </label>
          </div>
        </div>

        <div class="bg-iceberg p-6 flex flex-col flex-1">
          <div class="flex items-center justify-end mb-5">
            <button type="button" class="btn btn--secondary px-5 h-9 leading-4 text-center" routerLink="/dash/papeis">
              X
            </button>
          </div>

          <h2 class="text-lg text-chathams-blue font-bold leading-5 tracking-tight">
            Selecione a Configuração ao lado para liberar os acessos:
          </h2>

          <ng-container *ngIf="getCurrentResourceObject() | async as resourceFound">
            <div class="mt-6">
              <div class="flex flex-col w-full">
                <label class="text-lg text-chathams-blue font-bold mb-6 leading-5 tracking-tight">
                  {{ resourceFound.description }}:
                </label>

                <button class="btn btn--secondary w-50 leading-4 text-center h-9 mb-6" (click)="selecionarTodos()">
                  Selecionar Todos
                </button>
              </div>

              <div class="flex gap-y-6 flex-col mt-3">
                <div *ngFor="let group of permissionGroups" class="flex gap-y-4 flex-col">
                  <h3
                    *ngIf="group.title && permissionGroups.length > 1"
                    class="text-base text-chathams-blue font-bold leading-5 tracking-tight"
                  >
                    {{ group.title }}
                  </h3>

                  <ng-container *ngFor="let option of group.options">
                    <ng-container [formGroup]="option.item.control">
                      <div class="text-sm text-chathams-blue font-medium leading-4">
                        <input
                          type="checkbox"
                          class="mr-3 form-checkbox check-pink"
                          [id]="option.item.control.get('id')?.value"
                          formControlName="checked"
                          (change)="autoSetListPermission(option.item.control)"
                        />
                        <label [for]="option.item.control.get('id')?.value">
                          {{ option.label }}
                        </label>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="flex flex-col gap-y-4 h-full justify-end">
            <button
              *isAllowed="[ERoleAdminString.Admin, 'role.update']"
              type="button"
              class="btn btn--secondary w-full leading-4 text-center h-9"
              (click)="salvarAcesso()"
            >
              Salvar Acesso
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
